import { MostSearchedType } from '@/app/(main)/(pages)/_types/most-searched.type';
import { MostSearchedResult, MostSearchedResultType, SearchType } from '@/types/most-search-type';

export interface CardDisplayMostSearchedProps {
  isSingleCard: boolean;
  selectedProcedureList: MostSearchedResult[];
}

export type CardDisplayMostSearchedReturn = [MostSearchedResult[], MostSearchedResult[]];

export const cardDisplayMostSearched = ({
  isSingleCard,
  selectedProcedureList,
}: CardDisplayMostSearchedProps): CardDisplayMostSearchedReturn => {
  if (isSingleCard) {
    return [selectedProcedureList?.slice(0, 5) ?? [], []];
  }

  const maxSize = Number(selectedProcedureList?.length);
  const splitSize = Math.round(maxSize / 2);

  if (maxSize <= 2) {
    return [selectedProcedureList, []];
  } else if (maxSize <= 5) {
    return [selectedProcedureList?.slice(0, splitSize) ?? [], selectedProcedureList?.slice(splitSize, maxSize) ?? []];
  } else {
    const columnOne = selectedProcedureList?.slice(0, 5) ?? [];
    const columnTwo = selectedProcedureList?.slice(5, 9) ?? [];
    return [columnOne, columnTwo];
  }
};

const PRIORITY = [
  SearchType.PRESENTIAL_CONSULTATION,
  SearchType.ONLINE_CONSULTATION,
  SearchType.LABORATORIAL_EXAM,
  SearchType.IMAGE_EXAM,
];

export function getTopFilterType(procedures: MostSearchedResultType[]) {
  const typesSet = new Set(procedures.map((p) => p.type));
  return PRIORITY.find((type) => typesSet.has(type)) as MostSearchedType;
}

const PRIORITY_TWO = [
  SearchType.LABORATORIAL_EXAM,
  SearchType.IMAGE_EXAM,
  SearchType.PRESENTIAL_CONSULTATION,
  SearchType.ONLINE_CONSULTATION,
];

export function getBottomSearchType(procedures: SearchType[]) {
  const typesSet = new Set(procedures.map((p) => p));
  return PRIORITY_TWO.find((type) => typesSet.has(type));
}
